import React from 'react'

interface ArrowLeftProps {
  size?: number
  color?: string
  className?: string
  style?: React.CSSProperties
}

export const ArrowLeft: React.FC<ArrowLeftProps> = ({
  color = '#FFFFFF',
  size = 25,
  className,
  style,
  ...rest
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 25"
      fill="none"
      className={className}
      style={style}
      {...rest}
    >
      <path
        d="M10.7771 7.13679C11.1676 6.74627 11.1676 6.1131 10.7771 5.72258C10.3866 5.33206 9.75342 5.33206 9.36289 5.72258L3.29289 11.7926C3.10536 11.9801 3 12.2345 3 12.4997C3 12.7649 3.10536 13.0193 3.29289 13.2068L9.36289 19.2768C9.75342 19.6673 10.3866 19.6673 10.7771 19.2768C11.1676 18.8863 11.1676 18.2531 10.7771 17.8626L6.41453 13.5H20.9999C21.5522 13.5 21.9999 13.0523 21.9999 12.5C21.9999 11.9477 21.5522 11.5 20.9999 11.5H6.4139L10.7771 7.13679Z"
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </svg>
  )
}
